import { render, staticRenderFns } from "./chapterdel.vue?vue&type=template&id=c4e57f6c&scoped=true&"
import script from "./chapterdel.vue?vue&type=script&lang=js&"
export * from "./chapterdel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e57f6c",
  null
  
)

export default component.exports